import React from 'react'
import { NavLink } from 'react-router-dom'

// styles & images
import './Sidebar.css'
import DashboardIcon from '../../assets/dashboard_icon.svg'
import AddIcon from '../../assets/add_icon.svg'

// hooks
import { useAuthContext } from '../../Hooks/useAuthContext'
// components
import Avatar from '../avator/Avatar'

export default function Sidebar() {
    const { user } = useAuthContext()
    
    return (
        <div className='sidebar'>
            <div className="sidebar-content">
                <div className="user">
                    <Avatar image = {user.photoURL} />
                    {user && <p>Hey {user.displayName}!</p>}
                </div>
                <nav className="links">
                    <ul>
                        <li>
                            <NavLink exact to='/'>
                                <img src={DashboardIcon} alt="dashboard_icon" />
                                <span> Dashboard</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to='/create'>
                                <img src={AddIcon} alt="add_icon" />
                                <span> New Project</span>
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}
